import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { DilemmasHttpRepository } from "../repository";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@/constants/routes";

const dilemmasRepository = new DilemmasHttpRepository();

export function useFetchDilemma(id: string | undefined) {
  const navigate = useNavigate();
  const query = useQuery({
    queryKey: ["dilemma", id],
    queryFn: () => dilemmasRepository.fetchOne(id ?? ""),
    enabled: !!id,
    gcTime: 0,
  });

  useEffect(() => {
    if (query.error) {
      navigate(ROUTES.DILEMMAS);
    }
  }, [query.error, navigate]);

  return {
    dilemma: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
  };
}
